import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "card card-custom gutter-b",
    staticStyle: {
      "box-shadow": "none"
    }
  }, [_c('div', {
    staticClass: "card-header py-5"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" " + _vm._s(_vm.pageTitle) + " ")])])]), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Descriçao do kit",
      "label-for": "kitName"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.kitName,
      callback: function callback($$v) {
        _vm.kitName = $$v;
      },
      expression: "kitName"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Observação",
      "label-for": "kitObservacao"
    }
  }, [_c('b-form-input', {
    model: {
      value: _vm.kitObservacao,
      callback: function callback($$v) {
        _vm.kitObservacao = $$v;
      },
      expression: "kitObservacao"
    }
  })], 1)], 1)], 1), _c('b-row', {
    staticClass: "mb-2",
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    staticClass: "d-flex align-items-center",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    on: {
      "change": _vm.onToggleUsarUnidadeMedida
    },
    model: {
      value: _vm.usarUnidadeMedida,
      callback: function callback($$v) {
        _vm.usarUnidadeMedida = $$v;
      },
      expression: "usarUnidadeMedida"
    }
  }, [_vm._v(" Usar unidade de medida do kit ")])], 1), _vm.usarUnidadeMedida ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Unidade do kit",
      "label-for": "unidadeMedida"
    }
  }, [_c('VueSelect', {
    ref: "buscarUnidadeMedida",
    attrs: {
      "filterable": false,
      "options": _vm.unidadesMedidasFetched
    },
    on: {
      "search": _vm.onSearchUnidadeMedida,
      "input": _vm.onSelectUnidadeMedida
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " (" + _vm._s(option.sigla) + ") - conversor: " + _vm._s(option.conversor) + " ")])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.nome) + " (" + _vm._s(option.sigla) + ") ")])];
      }
    }], null, false, 2504891923),
    model: {
      value: _vm.unidadeMedidaSelected,
      callback: function callback($$v) {
        _vm.unidadeMedidaSelected = $$v;
      },
      expression: "unidadeMedidaSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe a unidade (fardo, caixa...) ")])], 2)], 1)], 1) : _vm._e(), _vm.usarUnidadeMedida ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Preço da unidade do kit R$",
      "label-for": "valorUnitarioKit"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "id": "valorUnitarioKit",
      "name": "valorUnitarioKit"
    },
    model: {
      value: _vm.valorUnitarioKit,
      callback: function callback($$v) {
        _vm.valorUnitarioKit = $$v;
      },
      expression: "valorUnitarioKit"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1) : _vm._e()], 1), _c('b-row', {
    attrs: {
      "align-v": "center"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Produto",
      "label-for": "name"
    }
  }, [_c('VueSelect', {
    ref: "buscarProduto",
    attrs: {
      "filterable": false,
      "options": _vm.produtosFetched
    },
    on: {
      "input": _vm.setProduto,
      "search": _vm.onSearchProduto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', [_vm._v(_vm._s(option.codigo) + " - " + _vm._s(option.descricao))]), _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("QTD: " + _vm._s(option.quantidade))])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_c('div', {
          staticClass: "selected d-center"
        }, [_vm._v(" " + _vm._s(option.codigo) + " - " + _vm._s(option.descricao) + " ")])];
      }
    }]),
    model: {
      value: _vm.produtoSelected,
      callback: function callback($$v) {
        _vm.produtoSelected = $$v;
      },
      expression: "produtoSelected"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v(" Informe o produto pelo nome ")])], 2)], 1)], 1)], 1), _c('b-alert', {
    staticClass: "mt-2 mb-2",
    attrs: {
      "show": _vm.usarUnidadeMedida,
      "variant": "info",
      "dismissible": ""
    }
  }, [_vm._v(" No modo \"unidade de medida do kit\" apenas "), _c('b', [_vm._v("1 produto")]), _vm._v(" compõe o kit. Ao vender, o kit é lançado como "), _c('b', [_vm._v("1 item")]), _vm._v(" (ex.: 1 fardo) com o preço da unidade do kit, baixando do estoque a quantidade convertida do produto base. ")]), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": _vm.windowWidth > 768 ? 0 : 6
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('money', _vm._b({
    ref: "quantidade",
    staticClass: "form-control",
    attrs: {
      "id": "quantidade",
      "name": "quantidade"
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleEnter('preco');
      }
    },
    model: {
      value: _vm.quantidade,
      callback: function callback($$v) {
        _vm.quantidade = $$v;
      },
      expression: "quantidade"
    }
  }, 'money', _vm.quantityOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth > 768 ? 0 : 6
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Unitário",
      "label-for": "preco"
    }
  }, [_c('money', _vm._b({
    ref: "preco",
    staticClass: "form-control",
    attrs: {
      "id": "preco",
      "name": "preco"
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.addProduto(_vm.produtoSelected);
      }
    },
    model: {
      value: _vm.preco,
      callback: function callback($$v) {
        _vm.preco = $$v;
      },
      expression: "preco"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', {
    attrs: {
      "cols": _vm.windowWidth > 768 ? 0 : 6
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Total R$",
      "label-for": "total"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "id": "total",
      "name": "total"
    },
    model: {
      value: _vm.total,
      callback: function callback($$v) {
        _vm.total = $$v;
      },
      expression: "total"
    }
  }, 'money', _vm.priceOptions, false))], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label-for": "add"
    }
  }, [_c('button', {
    on: {
      "click": function click($event) {
        return _vm.addProduto(_vm.produtoSelected);
      }
    }
  }, [_vm.windowWidth > 768 ? _c('Plus', {
    staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
  }) : _c('button', {
    staticClass: "btn btn-info btn-hover-dark font-weight-bolder font-size-lg ml-2"
  }, [_vm._v(" Adicionar produto ")])], 1)])], 1)], 1), _c('TableApp', {
    ref: "nome",
    attrs: {
      "item": "produto",
      "subTitulo": "",
      "data": _vm.produtos,
      "fields": _vm.fields,
      "classFilterColumn": "nome"
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'item' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "item"
          },
          slot: "item"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.originalIndex + 1) + " / " + _vm._s(props.rowData.product.codigo) + " ")])])]) : _vm._e(), props.field == 'descricao' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "nome"
          },
          slot: "nome"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(props.rowData.product.descricao) + " "), props.rowData.product.tipo_atacado ? _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.right",
            value: 'Item atendeu a regra de preço de atacado',
            expression: "\n                  'Item atendeu a regra de preço de atacado'\n                ",
            modifiers: {
              "hover": true,
              "right": true
            }
          }]
        }, [_c('InformationOutline', {
          attrs: {
            "size": 14
          }
        })], 1) : _vm._e()])])]) : _vm._e(), props.field == 'quantidade' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "quantidade"
          },
          slot: "quantidade"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.product.quantidade, "quantidade")) + " ")])])]) : _vm._e(), props.field == 'preco' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "preco"
          },
          slot: "preco"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold text-muted"
        }, [_vm._v(" " + _vm._s(_vm.numberToReal(props.rowData.product.preco, "preco")) + " ")])])]) : _vm._e(), props.field == 'total' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "total"
          },
          slot: "total"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.product.quantidade * props.rowData.product.preco, "preco")) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.openModalProduto(props.rowData, props.rowData.originalIndex);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.handleDeleteProduto(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)])])])]) : _vm._e()];
      }
    }])
  }), _vm.produtos.length > 0 ? _c('b-row', [_c('b-col'), _c('b-col'), _c('b-col', [_c('span', {
    staticClass: "text-primary font-weight-bolder"
  }, [_vm._v("Total Itens:")]), _vm._v(" " + _vm._s(_vm.numberToReal(_vm.produtos.reduce(function (acc, produto) {
    return acc + produto.product.quantidade;
  }, 0), "quantidade")))]), _c('b-col', [_c('span', {
    staticClass: "text-primary font-weight-bolder"
  }, [_vm._v("Total R$:")]), _vm._v(_vm._s(_vm.numberToReal(_vm.produtos.reduce(function (acc, produto) {
    return acc + produto.totalPrice;
  }, 0), "preco")))])], 1) : _vm._e()], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit-kit",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'kit'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])]), _vm.modalProdutoIsOpen ? _c('ModalProduto', {
    attrs: {
      "close": _vm.closeModalProduto,
      "changeProduto": _vm.saveEditProduto,
      "produto": _vm.produtoToEdit,
      "open": _vm.modalProdutoIsOpen
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };